module.exports = __webpack_public_path__ + "static/media/explore-image-4.64758296.jpg";